<template>
	<div>
		<div class="calcdetails">
			<div class="calclist d-flex open" :class="{ 'has-bg': !mobile }" style="justify-content: space-around;">
				<div class="calclist-boxes calclist-box-01" style="max-width: 20rem;">
					<div class="calclist-box-row-01 calclist-box-logo" v-if="mobile">
						<img :src="offer.logo" :alt="offer.insurer_name" />
					</div>
					<div class="calclist-box-row-01 calclist-box-title">{{ offer.insurer_name }} Biztosító</div>
					<div class="calclist-box-row-02 calclist-box-title product-name">{{ offer.product_name }}</div>
				</div>
				<div class="calclist-boxes calclist-box-02" :class="{ 'has-bg': mobile }" style="width: unset">
					<div class="calclist-box-row-01 details-box-title fs-bold" v-if="mobile">
						{{ offer.sum_fee | toCurrency }}
					</div>
					<div class="calclist-box-row-01 details-box-title" v-else>Biztosítási összeg lebontva:</div>
					<div class="calclist-box-row-02 details-box-desc">
						<ul>
							<li>Ingatlan: {{ detailValues(offer).insurance_value | toCurrency }}</li>
							<li>Ingóság: {{ detailValues(offer).movable_value | toCurrency }}</li>
							<li>Értéktárgy: {{ detailValues(offer).valuable_value | toCurrency }}</li>
							<li>
								Melléképület:
								{{
									outbuildingsValues(offer.detailedInsuranceValues.outbuilding).insurance_value
										| toCurrency
								}}
							</li>
							<li>
								Melléképület ingóság:
								{{
									outbuildingsValues(offer.detailedInsuranceValues.outbuilding).movable_value
										| toCurrency
								}}
							</li>
							<li>Építmények: {{ detailValues(offer).buildings_value | toCurrency }}</li>
						</ul>
					</div>
				</div>
				<div class="calclist-boxes calclist-box-04" v-if="!mobile" style="width: unset">
					<div class="calclist-box-row-01 details-box-title">Kedvezmények:</div>
					<div class="calclist-box-row-02 details-box-desc" style="margin-left: 15px">
						<ul>
							<li v-for="(discount, index) in offer.discounts" :key="index">
								{{ discount.name }}: {{ discountValue(discount) }}
							</li>
						</ul>
					</div>
				</div>
				<div class="calclist-boxes calclist-box-04 has-bg" v-else>
					<div class="calclist-box-row-01 details-box-title fs-bold">
						{{ offer.frequency_fee | toCurrency }}
					</div>
					<div class="calclist-box-row-02 details-box-desc">
						<ul>
							<li>{{ paymentFrequencyTexts[getCalculation.payment_frequency] }} fizetendő</li>
							<li>Évi: {{ offer.annual_fee | toCurrency }}</li>
						</ul>
					</div>
				</div>
				<div class="calclist-boxes calclist-box-05" v-if="mobile">
					<div class="calclist-box-row-02 details-box-desc mt-20px">
						<ul>
							<li v-for="(discount, index) in offer.discounts" :key="index">
								{{ discount.name }}: {{ discountValue(discount) }}
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
		<CalcResultBasicPackage :insurerCode="offer.insurer_code" v-if="!print"/>
		<CalcResultExtendPackage :offer="offer" />
	</div>
</template>

<script>
import CalcResultBasicPackage from '../components/CalcResultBasicPackage.vue';
import CalcResultExtendPackage from '../components/CalcResultExtendPackage.vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';

export default {
	components: {
		CalcResultBasicPackage,
		CalcResultExtendPackage,
	},
	props: {
		offer: { type: Object, default: () => {} },
		mobile: { type: Boolean, default: false },
        print: { type: Boolean, default: false },
	},
	data() {
		return {
			paymentFrequencyTexts: {
				0: 'Havonta',
				1: 'Negyedévente',
				2: 'Félévente',
				3: 'Évente',
			},
		};
	},
	computed: {
		...mapGetters(['getCalculation']),
		discountValue() {
			return discount => {
				return discount.percent === null
					? this.$options.filters.toCurrency(discount.value)
					: `${discount.percent}%`;
			};
		},
		outbuildingsValues() {
			return outbuildings => {
				return {
					insurance_value:
						_.sumBy(outbuildings, outbuilding => parseInt(outbuilding.insurance_value ?? 0)) ?? 0,
					movable_value: _.sumBy(outbuildings, outbuilding => parseInt(outbuilding.movable_value ?? 0)) ?? 0,
				};
			};
		},
		detailValues() {
			return offer => {
				return {
					insurance_value: parseInt(offer.real_estate_value ?? 0),
					movable_value: parseInt(offer.detailedInsuranceValues.main.movable_value ?? 0),
					valuable_value: parseInt(offer.valuables_value ?? 0),
					buildings_value: parseInt(offer.buildings_value ?? 0),
				};
			};
		},
	},
};
</script>
